export const errorMessages: Record<
  string,
  { message: string; alternative: string }
> = {
  INVOICE_NOT_FOUND: {
    message: 'Nota Fiscal não encontrada.',
    alternative: 'Verifique os dados informados e tente novamente.',
  },
  COMPANY_NOT_FOUND: {
    message: 'Empresa não encontrada.',
    alternative: 'Verifique os dados informados e tente novamente.',
  },
  MISSING_REQUIRED_ITEMS: {
    message: 'Itens obrigatórios não foram informados.',
    alternative: 'Preencha os campos obrigatórios para continuar.',
  },
  TITLES_ALREADY_EXIST_IN_OPERATION: {
    message: 'Os títulos já existem na operação.',
    alternative: 'Revise os títulos enviados e tente novamente.',
  },
  THERE_IS_NO_FILE_YET: {
    message: 'Nenhum arquivo encontrado!',
    alternative: 'Não há arquivos disponíveis para download.',
  },
  INSUFFICIENT_CREDIT_LIMIT: {
    message: 'Limite de crédito insuficiente.',
    alternative: 'Contate a operação.',
  },
  COMPANY_DONT_HAVE_SOLIDARY_PARTNER: {
    message: 'Cedente está sem responsável solidário.',
    alternative: 'Contate a operação.',
  },
  ACTION_NOT_ALLOWED: {
    message: 'Ação não permitida',
    alternative: 'Contate a operação.',
  },
  XML_ERROR_NOT_PROCESSED: {
    message: 'Erro ao processar o XML.',
    alternative: 'Verifique o arquivo e tente novamente.',
  },
  NOT_ALLOWED: {
    message: 'Operação não permitida.',
    alternative: 'Contate a operação.',
  },
  NOTE_ALREADY_REGISTERED: {
    message: 'Nota já cadastrada.',
    alternative: 'Verifique se a nota já foi processada.',
  },
  INSTALLMENT_NOT_FOUND: {
    message: 'Parcela da Nota Fiscal não encontrada.',
    alternative: 'Verifique os dados informados e tente novamente.',
  },
  AMOUNT_ALREADY_PAID: {
    message: 'Valor já foi pago.',
    alternative: 'Confira o histórico de pagamentos da parcela.',
  },
  INVALID_EXPIRATION_DATE: {
    message: 'Data de vencimento inválida.',
    alternative: 'Informe uma data de vencimento válida.',
  },
  LEAD_NOT_ACTIVE: {
    message: 'Cedente não está ativo.',
    alternative: 'Não é possível continuar enquanto o cadastro estiver inativo.',
  },
  INSTALLMENT_NOT_IN_STATUS_AVAILABLE: {
    message: 'Parcela da Nota Fiscal não está disponível para esta ação.',
    alternative: 'Verifique o status da parcela e tente novamente.',
  },
  LEAD_IS_NOT_GUARANTEED_OPERATION: {
    message: 'Cedente não pertence a uma operação garantida.',
    alternative: 'Verifique o tipo da operação antes de continuar.',
  },
  OPERATION_TYPES_CANT_BE_DIFFERENT: {
    message: 'Os tipos de operação não podem ser diferentes.',
    alternative: 'Padronize o tipo de operação para prosseguir.',
  },
  OPERATION_GUARANTOR_NOT_FOUND: {
    message: 'Garantidor da operação não encontrado.',
    alternative: 'Contate a operação.',
  },
  RESTITUTION_REQUEST_ALREADY_EXISTS: {
    message: 'Já existe uma solicitação de restituição.',
    alternative: 'Verifique a solicitação existente antes de criar outra.',
  },
  RESTITUTION_REQUEST_NOT_FOUND_FOR_THIS_INSTALLMENT: {
    message: 'Solicitação de restituição não encontrada para esta parcela.',
    alternative: 'Verifique a parcela informada e tente novamente.',
  },
  LAWYERS_NOT_FOUND: {
    message: 'Advogados não encontrados.',
    alternative: 'Cadastre ou vincule os advogados para continuar.',
  },
  REPORT_ERROR: {
    message: 'Erro ao gerar relatório.',
    alternative: 'Tente novamente mais tarde.',
  },
  TITLE_ALREADY_OPERATED_NOT_ALLOWED_CHANGE_TYPE_OPERATION: {
    message: 'Título já operado. Não é permitido alterar o tipo de operação.',
    alternative: 'Contate a operação para revisar o título.',
  },
  SEND_FILE_OR_BASE64: {
    message: 'Envie um arquivo ou conteúdo em base64.',
    alternative: 'Informe um dos formatos aceitos para continuar.',
  },
  INSTALLMENT_UPDATE_ERROR: {
    message: 'Erro ao atualizar a parcela.',
    alternative: 'Tente novamente e, se persistir, contate a operação.',
  },
  INVALID_TOKEN: {
    message: 'Token expirado.',
    alternative: 'Faça login novamente e tente continuar.',
  },
  LEAD_NOT_FOUND: {
    message: 'Cedente não encontrado.',
    alternative: 'Verifique os dados informados e tente novamente.',
  },
  NET_VALUE_NOT_FOUND: {
    message: 'Valor líquido não encontrado.',
    alternative: 'Verifique os dados da operação e tente novamente.',
  },
  OPERATION_ITEM_NOT_FOUND: {
    message: 'Item da operação não encontrado.',
    alternative: 'Verifique os dados informados e tente novamente.',
  },
  VALUE_EXCEEDED_REPURCHASE: {
    message: 'Valor excede o limite de recompra.',
    alternative: 'Revise os valores informados para recompra.',
  },
  DIFFERENT_LEAD_REPURCHASE: {
    message: 'Recompra com cedente diferente.',
    alternative: 'Selecione títulos do mesmo cedente para recompra.',
  },
  CONTAINS_MULTIPLE_LEAD_REPURCHASE: {
    message: 'A recompra contém múltiplos cedentes.',
    alternative: 'Selecione títulos de apenas um cedente.',
  },
  INTEREST_IS_NOT_ALLOWED_FOR_PAYMENTS_NOT_IN_DELAY: {
    message: 'Juros não permitido para pagamentos sem atraso.',
    alternative: 'Remova os juros ou informe uma parcela em atraso.',
  },
  EXCESSIVE_INTEREST_FOR_DUE_AMOUNT: {
    message: 'Juros excessivo para o valor em aberto.',
    alternative: 'Revise o valor de juros informado.',
  },
  CANNOT_CHANGE_WRITE_OFF_INSTALLMENT_STATUS: {
    message: 'Não é possível alterar o status de baixa da parcela.',
    alternative: 'Verifique as regras da operação e tente novamente.',
  },
  DRAWEE_NOT_CONTAINS_ADDRESS: {
    message: 'Sacado não possui endereço cadastrado.',
    alternative: 'Atualize o endereço do sacado para continuar.',
  },
  MORE_THAN_ONE_LEAD_NOT_ACCEPTABLE: {
    message: 'Não é possível selecionar notas de cedentes diferentes em uma única operação.',
    alternative: 'Selecione apenas um cedente para continuar.',
  },
  BUYER_DONT_HAVE_SOLIDARY_PARTNER: {
    message: 'Comprador não possui responsável solidário.',
    alternative: 'Contate a operação para vincular um responsável solidário.',
  },
  BUYER_DONT_HAVE_SUBSCRIBER: {
    message: 'Comprador não possui sócio assinante.',
    alternative: 'Contate a operação.',
  },
  LEAD_DONT_HAVE_SUBSCRIBER: {
    message: 'Cedente não possui sócio assinante.',
    alternative: 'Contate a operação.',
  },
  RESERVATION_CANNOT_BE_EXTENDED_MORE_THAN_2_TIMES: {
    message: 'A reserva não pode ser estendida mais de 2 vezes.',
    alternative: 'Contate a operação.',
  },
};

export const defaultErrorMessage = {
  message: 'Ocorreu um erro inesperado!',
  alternative: 'Tente novamente mais tarde.',
};
